export function leadingSlash (str) {
  return str.startsWith('/') ? str : '/' + str
}

export function trailingSlash (str) {
  return str.endsWith('/') ? str : str + '/'
}

export const wait = timeout => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export const nearestFutureMinutes = (interval, someMoment) => {
  const roundedMinutes = Math.ceil(someMoment.minute() / interval) * interval
  return someMoment.clone().minute(roundedMinutes).second(0)
}

export const nearestBeforeMinutes = (interval, someMoment) => {
  const roundedMinutes = Math.floor(someMoment.minute() / interval) * interval
  return someMoment.clone().minute(roundedMinutes).second(0)
}

export const snackbarOpen = (color, text, type) => {
  window.getApp.$emit('APP_SNACK_BAR', text, color, type)
}

export const snackbarInfo = (color, text, type) => {
  // type : success, info, warning, error
  return {
    show: true,
    color: color,
    text: text,
    type: type,
  }
}

export const getColorByStatus = (status, flag) => {
  const statusColors = {
    s: '#ACD373',
    r: '#3CB878',
    e: '#B7B7B7',
    q: 'blue',
    c: 'pink',
  }

  if (flag) {
    return flag === 'd'
      ? status === 'q'
        ? statusColors.c
        : statusColors.e
      : status === 'q'
        ? statusColors.q
        : statusColors.s
  } else {
    if (status === null) {
      return statusColors.e
    }
    return statusColors[status]
  }
}

export const goHome = (val) => {
  const nowPath = val.$route.path
  const items = val.$store.get('app@items')
  if (items[0].to === nowPath) {
    return
  }
  val.$router.push(items[0].to)
}

export const isValidateChcker = {
  ipAddress: value => {
    const pattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/
    return pattern.test(value) || 'Invalid IP Address.'
  },
  required: value => {
    return !!value || 'Required.'
  },
  number: value => {
    const pattern = /^\d*$/
    return pattern.test(value) || 'Invalid Number.'
  },
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return pattern.test(value) || 'Invalid e-mail.'
  },
}
